import { fetchApi } from './utils'

export const getAccountsUsers = async () => fetchApi('/users-for-account', { method: 'GET' })
export const addNewTeamMember = async (user) => fetchApi('/users-for-account', { method: 'PUT', params: { user } })